const convertToNumber = (val = '') => {
  if (val && !Number.isNaN(Number(val))) {
    return Number(val);
  }
  return val;
};

export default convertToNumber;
